import { UrlHelper } from './../helpers/url-helper';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatlink'
})
export class FormatlinkPipe implements PipeTransform {

  transform(url: any, urlType: string): any {
    switch(urlType) {
      case 'youtube':
        return UrlHelper.getFormattedYoutubeUrl(url);
      default:
        return '';
    }
  }

}
